import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("tj_token");
    if (!t) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch { localStorage.removeItem("tj_token"); setUser(null); }
    setLoading(false);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("tj_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const signup = async (name, email, password) => {
    const { data } = await api.post("/auth/signup", { name, email, password });
    localStorage.setItem("tj_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const loginWithToken = (token, userObj) => {
    localStorage.setItem("tj_token", token);
    setUser(userObj);
    return userObj;
  };
  const logout = () => {
    // Clear ALL user-scoped localStorage keys so a re-login on the SAME
    // browser doesn't inherit the previous account's TradingView workspace,
    // chart drawings, currency, or on-chart SL/TP shapes (cross-account
    // leak bug user hit: account A's marks visible on account B).
    try {
      localStorage.removeItem("tj_token");
      localStorage.removeItem("tj_user_id");
      // Wipe every TV-persisted key — save_load_adapter buckets, per-symbol
      // source preference, last-chart cache — so the next user starts clean.
      const keys = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (!k) continue;
        if (k.startsWith("tv_") || k.startsWith("tradingview") || k.startsWith("tj_") || k.includes("chart")) keys.push(k);
      }
      keys.forEach(k => localStorage.removeItem(k));
    } catch (_) {}
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, login, signup, loginWithToken, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
